import React from "react";
import Header from "../../components/Header/Header";
import { Box } from '@material-ui/core';

import {withStyles} from "@material-ui/core";
import HeaderLinks from "../../components/Header/HeaderLinks";
import BaseHeaderLinks from "./BaseHeaderLinks";
import intl from "react-intl-universal";


class BaseHeader extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		// const {classes} = this.props;
		const {...rest} = this.props;



		return (
			<>
				 <Box style={{width: '100%', background: '#ff9800', color: '#fff', textAlign: 'center', padding: '8px 0', fontWeight: 600, letterSpacing: 2, fontSize: 16, zIndex: 2000, position: 'fixed', left: 0, whiteSpace: 'pre-line', lineHeight: 1.2}}>
				 {intl.get('sorry')}<a href={"https://github.com/clwater/LeetCodeAllAnimation"}>https://github.com/clwater/LeetCodeAllAnimation</a>
				 </Box>
				<Header
					brand="RobinAlgo"
					links={<BaseHeaderLinks dropdownHoverColor="info" />}
				// fixed
				color="transparent"
				changeColorOnScroll={{
					height: 400,
					color: "white"
				}}
				{...rest}
			/>
			</>
		)

	}

}

export default BaseHeader

